import { DEFAULT_CHAINID } from '~/config/*'
import { multicall } from '@/lib/web3/multicall'
import useSWR from 'swr'
import getChainConfig from '@/lib/web3/getChainConfig'
import { VAULTPROXY } from '@/contract/abi'
import { formatEther, parseEther } from 'viem'
import { useWeb3ModalAccount } from '@web3modal/ethers/react'
import useHomeHooks from './useHomeHooks'
import BigNumber from 'bignumber.js'

export default function useWithdrawRewardToFastToken() {
	const currentChainId = DEFAULT_CHAINID
	const { isConnected, address } = useWeb3ModalAccount()
	// 合约信息
	const { contracts } = getChainConfig()
	const VaultProxy_ADDRESS = contracts['VaultProxy_ADDRESS']

	const { rewards } = useHomeHooks().data
	const total = new BigNumber(rewards.other).plus(rewards.team).toString()

	const { data, ...args } = useSWR(
		isConnected && address ? ['useWithdrawRewardToFastToken', total] : null,
		async ([_, number]) => {
			return await multicall(currentChainId, {
				contracts: [
					{
						address: VaultProxy_ADDRESS,
						abi: VAULTPROXY,
						functionName: 'rewardToFastToken',
						args: [parseEther(number.toString())],
					},
				],
			}).then(res => {
				return {
					withdrawRewardToFastToken: Number(formatEther((res[0].status === 'success' ? res[0].result : 0) as bigint)),
				}
			})
		},
		{
			revalidateIfStale: false,
			revalidateOnFocus: false,
		},
	)

	return {
		data: {
			withdrawRewardToFastToken: data?.withdrawRewardToFastToken || 0,
		},
		loading: args.isLoading || args.isValidating,
		...args,
	}
}
